import { Injectable } from '@angular/core';
import { idNameItem,  } from 'jk-service';
import { StkmmServicePkg } from './stkmmPkg.service';

export const stkmmOrderList: idNameItem[] = [
  {
    id: 'ORDER BY MM004 DESC,MM003,MM002',
    name: '依日期倒序+股票代號+條件代號',
  },
  {
    id: 'ORDER BY MM003,MM004 DESC,MM002',
    name: '依股票代號+日期倒序+條件代號',
  },
  {
    id: 'ORDER BY MM002,MM003,MM004 DESC',
    name: '依條件代號+股票代號+日期倒序',
  },
];

@Injectable({
  providedIn: 'root'
})
export class StkmmService extends StkmmServicePkg {
  constructor() {
    super();
    /*this.idNameOpt.sqlSelect= `SELECT ME001 as id,ME002 as name,ME001+'-'+ME002 as idName,ME002+'-'+ME001 as nameId,ME003 as ps1 FROM STKME `;
    this.idNameOpt.sqlWhere= `  `
    this.idNameOpt.sqlOrder= 'ORDER BY ME001';
    this.loadIdNameList(this.idNameOpt);*/

  }
  async getLastDay():Promise<string>{
    const sql = `SELECT TOP 1 MM004 FROM STKMM ORDER BY MM004 DESC `;
    const ds: any[] = await this.jkBDb.simpleSql(sql);
    if (ds && ds.length > 0) {
      return ds[0].MM004;
    }else{
      return this.nowDate();
    }
  }
}


